export type ObjectStoreSchema = NonNullable<unknown>
export type DatabaseSchema = Record<string, ObjectStoreSchema>
